import { ValuablesProductFormState } from "Components/Features/CheckPrice/Products/RiskProducts/Valuables";
import { VALUABLE_ABOUT } from "Components/Features/CheckPrice/Products/RiskProducts/Valuables/valuablesConstants";
import { mapFormToPriceRequest } from "Components/Features/CheckPrice/Products/RiskProducts/Valuables/valuablesUtils/mapFormToPriceRequest";
import { DamageRecentYears } from "Components/Form/RecentDamages/recentDamagesInterfaces";
import { INSURANCE_NAME_VALUE } from "Store/interfaces/products";
import { ValuablesCoverage } from "Store/interfaces/products/coverage";
import { mapFormToInjuries } from "Store/priceCalculation/productMappers/common/injuriesMapper";

export const mapToCommerceValuables = (data: any): any => {
  const formValues: ValuablesProductFormState =
    data.formData[VALUABLE_ABOUT.id];
  const mappedValues = mapFormToPriceRequest(formValues);
  return {
    name: INSURANCE_NAME_VALUE.VALUABLES,
    coverageGroup: ValuablesCoverage.VALUABLES,
    ...mappedValues,
    ...mapFormToInjuries(
      String(mappedValues.injuries) as DamageRecentYears,
      mappedValues.injuryYear ? String(mappedValues.injuryYear) : undefined,
    ),
  };
};
